import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const exportDeclarationApi = createApi({
  reducerPath: "exportDeclarationApi",
  baseQuery,
  tagTypes: ["ExportDeclaration"],

  endpoints: (builder) => ({
    // 🔍 GET declaration
    getDeclaration: builder.query({
      query: ({ exporterMasterId }) =>
        `export/Declaration/${exporterMasterId}`,
      transformResponse: (response) => response?.data,
      providesTags: ["ExportDeclaration"],
    }),

    createDeclaration: builder.mutation({
      query: ({ exporterMasterId, ...data }) => {

        return {
          url: `export/Declaration/${exporterMasterId}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: {
            declaration: data,
          },
        };
      },
      invalidatesTags: ["ExportDeclaration"],
    }),
    

    // 🔄 UPDATE Declaration
    updateDeclaration: builder.mutation({
      query: ({ exporterMasterId, declarationId, ...data }) => ({
        url: `export/Declaration/${exporterMasterId}/${declarationId}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: {
          declaration: data,
        },
      }),
      invalidatesTags: ["ExportDeclaration"],
    }),

    // ❌ DELETE Declaration
    deleteDeclaration: builder.mutation({
      query: ({ declarationId }) => ({
        url: `export/Declaration/${declarationId}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["ExportDeclaration"],
    }),
  }),
});

export const {
  useGetDeclarationQuery,
  useLazyGetDeclarationQuery,
  useCreateDeclarationMutation,
  useUpdateDeclarationMutation,
  useDeleteDeclarationMutation,
} = exportDeclarationApi;
